// extracted by mini-css-extract-plugin
export default {"root":"_3l6QY","logoWrapper":"_1K5AP","action":"_1H6kw","text":"_2zqZ6","emphasis":"CipS9","buttonLink":"_33Qx0","button":"GamAL"};